import React, { Component } from "react";
import { connect } from "react-redux";
import IntlMessages from "../../../utils/IntlMessages";
import { authClosePopup } from "../../../actions";
import Authen from "../../../app/routes/authen_for_modal";

import "../../../assets/css/abbott-popup.scss";

class PopupAuth extends Component {
  onClickClose = (e) => {
    this.props.authClosePopup();
  };

  render() {
    if (!this.props.displayPopupRequestAuth) {
      return <div></div>;
    }
    return (
      <div
        className="modal fade show"
        role="dialog"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header text-center">
              <h1 className="modal-title">
                <IntlMessages id="authen.sign-in"></IntlMessages>
              </h1>
            </div>
            <div className="modal-body">
              <Authen />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ setting, auth: { displayPopupRequestAuth } }) => {
  const {
    locale: { locale },
  } = setting;
  return { locale, displayPopupRequestAuth };
};

export default connect(mapStateToProps, {
  authClosePopup,
})(PopupAuth);
